import { render } from "./TechnicianIndex.vue?vue&type=template&id=52ea2454"
import script from "./TechnicianIndex.vue?vue&type=script&lang=js"
export * from "./TechnicianIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__